module.exports = __webpack_public_path__ + "img/finish.091abbcd.png";